'use strict'

angular.module('rmTrashcan')
    .controller('TrashcanOverviewCtrl', require('./trashcan_overview_ctrl'))
